module.exports = __webpack_public_path__ + "models/sensor_a578b22566ff8f010a18dfcdd7ec8791.glb";